import React from "react";
import {Box, IconButton, Tooltip} from "@mui/material";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import {useTranslation} from "react-i18next";

const TablePaginationActions = ({count, page, rowsPerPage, onPageChange}) => {
    const {t} = useTranslation();
    const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);

    const moveToFirst = (event) => onPageChange(event, 0);
    const moveToPrevious = (event) => onPageChange(event, Math.max(page - 1, 0));
    const moveToNext = (event) => onPageChange(event, Math.min(page + 1, lastPage));
    const moveToLast = (event) => onPageChange(event, lastPage);

    return (
        <Box sx={{flexShrink: 0, ml: 1.5, display: "flex", gap: 0.5}}>
            <Tooltip title={t("common.firstPage") || "First Page"}>
                <span>
                    <IconButton onClick={moveToFirst} disabled={page === 0} aria-label="first page" size="small">
                        <FirstPageIcon fontSize="small"/>
                    </IconButton>
                </span>
            </Tooltip>

            <Tooltip title={t("common.previousPage") || "Previous Page"}>
                <span>
                    <IconButton onClick={moveToPrevious} disabled={page === 0} aria-label="previous page" size="small">
                        <KeyboardArrowLeft fontSize="small"/>
                    </IconButton>
                </span>
            </Tooltip>

            <Tooltip title={t("common.nextPage") || "Next Page"}>
                <span>
                    <IconButton
                        onClick={moveToNext}
                        disabled={page >= lastPage}
                        aria-label="next page"
                        size="small"
                    >
                        <KeyboardArrowRight fontSize="small"/>
                    </IconButton>
                </span>
            </Tooltip>

            <Tooltip title={t("common.lastPage") || "Last Page"}>
                <span>
                    <IconButton
                        onClick={moveToLast}
                        disabled={page >= lastPage}
                        aria-label="last page"
                        size="small"
                    >
                        <LastPageIcon fontSize="small"/>
                    </IconButton>
                </span>
            </Tooltip>
        </Box>
    );
};

export default TablePaginationActions;
